import { useNavigate } from "react-router-dom"
import Router from "@/router/router"
import { useSetUpAxios } from "./app/api"
export default function App() {
  const navigate = useNavigate()
  const { search } = useLocation();


  useEffect(() => {
    navigate("/" + search)
  }, [])
  useSetUpAxios()
  return <Router />
}
